import React, { useContext, useEffect, useState } from 'react'
import { useImmer } from 'use-immer';
import GlobalContext from '../GlobalContext';
import AdminConsole from '../admin_components/AdminConsole';

const AdminLogin = () => {

    const globalContext=useContext(GlobalContext)
    const [loginData, setLoginData] = useImmer({
        username: '',
        password: ''
    })
    const [logged, setLogged]=useState(false)
    const [loginError, setLoginError] = useState(false)

    const sendLogin = async () => {

        const resp = await fetch(`${globalContext.get.backendUrl}/login/admin`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: loginData.username, password: loginData.password })
        })
        setLoginData({
            username: '',
            password: ''
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            isLogged()
            setLoginError(false)
        }
        else {
            setLoginError(true)
        }
    }
    const isLogged = async () => {
        const resp = await fetch(`${globalContext.get.backendUrl}/login/admin`, {
            method: 'GET',
            credentials: 'include',
        })
        const respValue = await resp.json()

        if (resp.status == 200) {
            setLogged(true)
        } else {
            setLogged(false)
        }
    }

    useEffect(()=>{
        isLogged()
    },[])

    return (
        <>
        {logged?(
            <AdminConsole />
        ):(
            <div style={{ padding: '100px' }} >
                <h1>Attenzione, questa pagine è riservata al personale NACweb, non dovresti trovarti qui!</h1>
                <hr />
                <form>
                    <input
                        type='text'
                        placeholder='username'
                        value={loginData.username}
                        onChange={(e) => setLoginData(draft => { draft.username = e.target.value })}
                    />
                    <input
                        type='password'
                        placeholder='password'
                        value={loginData.password}
                        onChange={(e) => setLoginData(draft => { draft.password = e.target.value })}
                    />
                    <input
                        type='submit'
                        placeholder='login'
                        title='login'
                        onClick={(e) => { e.preventDefault(); sendLogin() }}
                    />
                </form>
                {loginError&&(
                    <p>Username o password errati</p>
                )}
            </div>
        )}
        </>
    )
}

export default AdminLogin